module.exports = __webpack_public_path__ + "img/img3-bg.48207136.png";